import { DEFAULT_LOGO_URL } from '@/lib/consts/urls';
import type { BootAuthResponse } from '@/lib/types';
import { ELoginDesignId } from '@/lib/types/boot';

export const resolveLoginLogoUrl = (authBoot: BootAuthResponse): string =>
  authBoot.storeTheme.login?.loginLogoImage ||
  authBoot.storeTheme.general?.logo ||
  DEFAULT_LOGO_URL;

/**
 * Designs that pick their logo with a `<picture>` media query. `preload` takes
 * no `media`, so preloading one of these would fetch the wrong breakpoint's art.
 */
const RESPONSIVE_LOGO_DESIGNS = new Set<ELoginDesignId>([
  ELoginDesignId.JACKPOT_SLOTS,
  ELoginDesignId.BIG_FISH_CASINO,
]);

export const shouldPreloadLoginLogo = (loginDesignId?: ELoginDesignId): boolean =>
  !loginDesignId || !RESPONSIVE_LOGO_DESIGNS.has(loginDesignId);
